import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { faClipboardList, faFileLines, faFilePdf, faMessages } from "@performyard/fontawesome/pro-regular-svg-icons";
import type { TemplateLibraryEntryTypeEnum } from "@performyard/service-contracts";

export type TypeMeta = {
	label: string;
	plural: string;
	short: string;
	icon: IconDefinition;
};

export const TYPE_META: Record<TemplateLibraryEntryTypeEnum, TypeMeta> = {
	review_workflow: {
		label: "Review template",
		plural: "Templates",
		short: "Template",
		icon: faClipboardList,
	},
	review_form: {
		label: "Review form",
		plural: "Forms",
		short: "Form",
		icon: faFileLines,
	},
	survey: {
		label: "Engagement survey",
		plural: "Surveys",
		short: "Survey",
		icon: faMessages,
	},
	pdf_guide: {
		label: "Document",
		plural: "Documents",
		short: "Document",
		icon: faFilePdf,
	},
};

export const TYPE_ORDER: TemplateLibraryEntryTypeEnum[] = ["review_workflow", "review_form", "survey", "pdf_guide"];
